import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Box, Typography, Button, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import './ConfirmationModal.css';
import StyledTextField from '../StyledComponents/StyledTextField';

const ConfirmationModal = ({ open, onClose, title, subtitle, children, onSubmit, isDanger, hasNotes, onNoteChange }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-subtitle"
    >
      <Box className="modal-box">
        <IconButton
          onClick={onClose}
          className="close-button"
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-title" variant="h5" className={`modal-title ${isDanger? 'danger-title' : ''}`}>
          {title}
        </Typography>
        <Typography id="modal-subtitle" variant="subtitle1" className="modal-subtitle">
          {subtitle}
        </Typography>
        <Box className="modal-content">
          {children}
          {hasNotes && (
            <StyledTextField
              label="Notes"
              multiline
              rows={2}
              variant="outlined"
              fullWidth
              onChange={(e) => onNoteChange(e.target.value)}
              className="notes-field"
              margin="normal"
            />
          )}
        </Box>
        <Button
          onClick={onSubmit}
          variant="contained"
          color="primary"
          className={`submit-button ${isDanger? 'danger-button' : ''}`}
        >
          Confirm
        </Button>
      </Box>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  onSubmit: PropTypes.func.isRequired,
  hasNotes: PropTypes.bool,
  onNoteChange: PropTypes.func,
};

export default ConfirmationModal;
